export const getEnv = () => {
  switch (process.env?.REACT_APP_ENV?.toLowerCase()) {
    case "development":
      return {
        apiURL: process.env.REACT_APP_API_BASE_DEV_URL,
        scriptURL: process.env.REACT_APP_SCRIPT_DEV_URL,
        rezorpayKeyID: process.env.REACT_APP_RAZORPAY_KEY_ID_DEV,
        microsoftRegisterRedirectUrl: process.env.REACT_APP_MICROSOFT_AUTH_REGISTER_DEV,
        microsoftAgentLoginRedirectUrl: process.env.REACT_APP_MICROSOFT_AUTH_AGENT_LOGIN_DEV,
        microsoftClientLoginRedirectUrl: process.env.REACT_APP_MICROSOFT_AUTH_CLIENT_LOGIN_DEV,
        referUrl: process.env.REACT_APP_API_REFER_DEV_URL
      };
    case "production":
      return {
        apiURL: process.env.REACT_APP_API_BASE_PROD_URL,
        scriptURL: process.env.REACT_APP_SCRIPT_PROD_URL,
        rezorpayKeyID: process.env.REACT_APP_RAZORPAY_KEY_ID_PROD,
        microsoftRegisterRedirectUrl: process.env.REACT_APP_MICROSOFT_AUTH_REGISTER_PROD,
        microsoftAgentLoginRedirectUrl: process.env.REACT_APP_MICROSOFT_AUTH_AGENT_LOGIN_PROD,
        microsoftClientLoginRedirectUrl: process.env.REACT_APP_MICROSOFT_AUTH_CLIENT_LOGIN_PROD,
        referUrl: process.env.REACT_APP_API_REFER_PROD_URL
      };
    default:
      return {
        apiURL: process.env.REACT_APP_API_BASE_DEV_URL,
        scriptURL: process.env.REACT_APP_SCRIPT_DEV_URL,
        rezorpayKeyID: process.env.REACT_APP_RAZORPAY_KEY_ID_DEV,
        microsoftRegisterRedirectUrl: process.env.REACT_APP_MICROSOFT_AUTH_REGISTER_DEV,
        microsoftAgentLoginRedirectUrl: process.env.REACT_APP_MICROSOFT_AUTH_AGENT_LOGIN_DEV,
        microsoftClientLoginRedirectUrl: process.env.REACT_APP_MICROSOFT_AUTH_CLIENT_LOGIN_DEV,
        referUrl: process.env.REACT_APP_API_REFER_DEV_URL
      };
  }
};
